import { render, staticRenderFns } from "./AbsenceJustifiedDayLegend.vue?vue&type=template&id=220f41e7&"
import script from "./AbsenceJustifiedDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceJustifiedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports